__turbopack_context__.v({
  "Main": "GNnQpq_Main",
  "skeleton-loading": "GNnQpq_skeleton-loading",
});
